/**
 * One headline stat: label + value. Optional `sub` line (e.g. "+238d from
 * baseline") renders below, colorable via `subVariant` which maps to the
 * usual severity color ramp.
 */
export function StatCard({ label, value, sub, subVariant }) {
  const subClass = subVariant ? `stat-sub stat-sub-${subVariant}` : 'stat-sub';
  return (
    <div className="stat-card">
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub && <div className={subClass}>{sub}</div>}
    </div>
  );
}
